/**
 * One shared /sw.js, registered once per studio with scope /s/<slug>/.
 * Each registration derives its own cache names from its scope, so studios
 * never share caches. Disabled in development.
 */
export async function registerTenantServiceWorker(slug: string): Promise<ServiceWorkerRegistration | null> {
  if (!__SW_ENABLED__ || !('serviceWorker' in navigator)) return null;
  try {
    return await navigator.serviceWorker.register('/sw.js', { scope: `/s/${slug}/`, updateViaCache: 'none' });
  } catch (e) {
    console.warn('service worker registration failed', e);
    return null;
  }
}

export async function tenantRegistration(slug: string): Promise<ServiceWorkerRegistration | undefined> {
  if (!('serviceWorker' in navigator)) return undefined;
  return navigator.serviceWorker.getRegistration(`/s/${slug}/`);
}

/** Asks the studio's worker to drop any runtime caches (used on owner logout). */
export async function clearPrivateCaches(slug: string): Promise<void> {
  const reg = await tenantRegistration(slug);
  reg?.active?.postMessage({ type: 'CLEAR_PRIVATE' });
  if ('caches' in window) {
    const names = await caches.keys();
    await Promise.all(names.filter((n) => n.startsWith(`studio-${slug}-private`)).map((n) => caches.delete(n)));
  }
}
